import { Formik } from 'formik';
import { useMutation } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { backend } from '../axios/backend';
import InputFormik from '../components/formik/InputFormik';
import Sad from '../components/icons/Sad';
import PrettyLoader from '../components/PrettyLoader';
import ProductComponent from '../components/ProductComponent';
import Breadcrumbs from '../components/ui/Breadcrumbs';
import Button from '../components/ui/Button';
import { useAppContext } from '../context/AppContext';
import { useSharedWishes } from '../hooks/useSharedWishes';

const SharedWishesPage = () => {
  const { sharedId } = useParams();
  const { user, isAuthenticated, preUser, preUserMutation, alertSuccess, alertError } = useAppContext();
  const navigate = useNavigate();

  const query = useSharedWishes(sharedId || '', user?.id, { refetchOnMount: false });

  const addToSharedWithMeMutation = useMutation(() => backend.post(`wish/shared/add/shared-with-me/${sharedId}`), {
    onSuccess: () => {
      alertSuccess('Erfolgreich hinzugefügt');
      navigate('/shared-with-me');
    },
    onError: () => alertError('Fehler beim Hinzufügen.'),
  });

  return (
    <div style={{ margin: '2rem' }}>
      <PrettyLoader useQueryResult={query}>
        {user?.id === query.data?.sharedBy.id ? (
          <div className="flex flex-row text-gray-400 text-center space-x-2 justify-center align-center">
            <span className="text-yellow-700 text-center">
              <Sad />
            </span>
            <span>Na na, du willst dich doch nicht selbst spoilern, oder?</span>
          </div>
        ) : isAuthenticated && !query.data?.isInSharedWithMe ? (
          <div className="space-y-2">
            <h1 className="text-white text-lg">
              {query.data?.sharedBy.firstname} hat {query.data?.wishes.length} Wünsche mit dir geteilt!
            </h1>
            <Button onClick={() => addToSharedWithMeMutation.mutate()} isLoading={addToSharedWithMeMutation.isLoading}>
              Zu "Mit mir geteilt" hinzufügen
            </Button>
          </div>
        ) : !preUser && !isAuthenticated ? (
          <div className="space-y-2">
            <h1 className="text-white text-lg">
              {query.data?.sharedBy.firstname} hat {query.data?.wishes.length} Wünsche mit dir geteilt!
            </h1>
            <p className="text-sm text-gray-400">
              Um Wünsche zu sehen und diese zu reservieren musst du deinen Namen angeben:
            </p>
            <Formik initialValues={{ name: '' }} onSubmit={(values) => preUserMutation?.mutate({ name: values.name })}>
              {({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <div className="flex flex-row space-x-2">
                    <InputFormik name="name" placeholder="Name" isRequired />
                    <div className="self-end">
                      <Button type="submit" isLoading={preUserMutation?.isLoading}>
                        Erstellen
                      </Button>
                    </div>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        ) : (
          <>
            {!isAuthenticated && preUser && (
              <div className="flex flex-row justify-between ">
                <div>
                  <h1 className="text-white text-lg">Mit {preUser.name} geteilte Wünsche</h1>
                  <h3 className="text-white text-md">Von {query.data?.sharedBy.firstname}</h3>
                </div>
              </div>
            )}
            {isAuthenticated && query.data?.isInSharedWithMe && (
              <div className="space-y-2">
                <Breadcrumbs
                  crumbs={[
                    { text: 'Mit mir geteilt', route: '/shared-with-me' },
                    { text: `Wünsche von ${query.data.sharedBy.firstname}`, route: `/shared-wishes/${sharedId}` },
                  ]}
                />
                <h1 className="text-white text-xl">
                  <b>
                    Wünsche von {query.data?.sharedBy.firstname} {query.data.sharedBy.lastname}
                  </b>
                </h1>
              </div>
            )}

            <ul className="divide-y divide-gray-400 mb-4">
              {query.data?.wishes.map((wish) => (
                <ProductComponent
                  key={wish.id}
                  product={wish}
                  onClick={() => {
                    navigate(`/shared-wishes/${sharedId}/${wish.id}`);
                  }}
                  withMarks
                />
              ))}
            </ul>

            {!isAuthenticated && (
              <div className="flex flex-col items-center space-y-2">
                <p className="text-white">Eigene Wünsche und Ideen speichern und mit Freunden teilen?</p>
                <Button onClick={() => navigate(`/register/${sharedId}`)}>Jetzt kostenlos registrieren</Button>
              </div>
            )}
          </>
        )}
      </PrettyLoader>
    </div>
  );
};

export default SharedWishesPage;
